// Where a tapped notification opens (shared/push.ts LINK): pure, so the tests can check every link.
// main.ts reads the hash once (handleLinkInUrl()), clears it, and applies the result through go()
// and the existing actions: the Accept sheet only through 'split-accept-open' (acceptStart() /
// acceptSheetFor()), a purchase through its New purchases Edit sheet or the edit sheet.
export type PushLink =
  | { kind: 'review' }
  | { kind: 'tx'; id: string }
  | { kind: 'accept'; id: string }
  | { kind: 'splits' }
  | { kind: 'overview' };

export function readPushLink(hash: string): PushLink | null {
  if (hash === '#review') return { kind: 'review' };
  if (hash === '#splits') return { kind: 'splits' };
  if (hash === '#overview') return { kind: 'overview' };
  const m = /^#(tx|accept)=([\w-]{1,64})$/.exec(hash);
  return m ? { kind: m[1] as 'tx' | 'accept', id: m[2] } : null;
}

/** A purchase to open: its New purchases Edit sheet while it waits for review, else its edit sheet. */
export const sheetFor = (t: { reviewed: boolean }): 'new-edit' | 'edit' => (t.reviewed ? 'edit' : 'new-edit');

/** Copy when the thing a notification pointed at is gone (answered, deleted, or in another month). */
export const LINK_SPLIT_GONE = 'That split request was already answered or cancelled.';
